import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface PaginationInfoProps {
  current: number;
  total: number;
  pageSize?: number;
}

const PaginationInfo = ({ current, total, pageSize = 10 }: PaginationInfoProps) => {
  const { t } = useTranslation();
  return (
    <Text>{`${current} - ${Math.min(current + pageSize - 1, total)} ${t(
      "OF"
    )} ${total}`}</Text>
  );
};

export default PaginationInfo;
